<!-- Preloader -->

<div class="preloader">
	<div class="spinner-wrap">
		 <div class="preloader-logo">
			<img src="assets/images/loading.png" alt="Spinner RiverApp" class="img-fluid">
		 </div>
		 <div class="spinner"></div> 
	</div>
</div>

<!-- Preloader End -->